function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { createRef } from "react";
import isEqual from "lodash/isEqual";
import ExtensionAPI from "../../utils/ExtensionAPI";
import highlightCode from "../../utils/codeHighlight";
import { getBackgroundOption, getContrast, getFontSize, updateBackgroundOption, updateContrast, updateFontSize } from "../../utils/accessibility";
import { updateBodyClass } from "../../utils/updateBodyClass";
import { applyColorMode } from "../../utils/colorMode";
var checkLoaded = function(frame, ready) {
    if (!frame) {
        return;
    }
    var doc = frame.contentDocument || frame.contentWindow && frame.contentWindow.document;
    if (doc && doc.URL.indexOf("about:") !== 0) {
        if (doc.readyState === "complete") {
            ready(frame);
        } else {
            doc.addEventListener("DOMContentLoaded", function() {
                return ready(frame);
            });
            doc.addEventListener("readystatechange", function() {
                if (doc.readyState === "complete" || doc.readyState === "interactive") {
                    ready(frame);
                }
            });
        }
    } else {
        setTimeout(function() {
            return checkLoaded(frame, ready);
        }, 1);
    }
};
var ExtensionTemplate = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(ExtensionTemplate, _React_Component);
    var _super = _createSuper(ExtensionTemplate);
    function ExtensionTemplate(props) {
        _classCallCheck(this, ExtensionTemplate);
        var _this;
        _this = _super.call(this, props);
        _this.proxyEvents = function(e) {
            var proxiedEvent = new CustomEvent("extension-keydown", {
                detail: {
                    originalEvent: e
                }
            });
            window.dispatchEvent(proxiedEvent);
        };
        _this.storyModeRef = /*#__PURE__*/ createRef();
        _this.bookModeRef = /*#__PURE__*/ createRef();
        _this.currentIFrame = null;
        return _this;
    }
    var _proto = ExtensionTemplate.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this_currentIFrame;
        var _this_props = this.props, storyMode = _this_props.storyMode, content = _this_props.content, cBookLang = _this_props.cBookLang, frame = _this_props.frame;
        if (!storyMode && content && content.book_mode && content.book_mode.enabled) {
            var _this_bookModeRef, _this_storyModeRef;
            ((_this_bookModeRef = this.bookModeRef) === null || _this_bookModeRef === void 0 ? void 0 : _this_bookModeRef.current) && this.bookModeRef.current.setAttribute("style", "opacity: 1; display: block;");
            ((_this_storyModeRef = this.storyModeRef) === null || _this_storyModeRef === void 0 ? void 0 : _this_storyModeRef.current) && this.storyModeRef.current.setAttribute("style", "opacity: 0; display: none;");
        } else {
            var _this_bookModeRef1, _this_storyModeRef1;
            ((_this_bookModeRef1 = this.bookModeRef) === null || _this_bookModeRef1 === void 0 ? void 0 : _this_bookModeRef1.current) && this.bookModeRef.current.setAttribute("style", "opacity: 0; display: none;");
            ((_this_storyModeRef1 = this.storyModeRef) === null || _this_storyModeRef1 === void 0 ? void 0 : _this_storyModeRef1.current) && this.storyModeRef.current.setAttribute("style", "opacity: 1; display: block;");
        }
        if ((_this_currentIFrame = this.currentIFrame) === null || _this_currentIFrame === void 0 ? void 0 : _this_currentIFrame.contentWindow) {
            this.currentIFrame.contentWindow.addEventListener("keydown", this.proxyEvents);
        }
        this.setIFrameLang(cBookLang);
        highlightCode(frame);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _this_currentIFrame;
        if ((_this_currentIFrame = this.currentIFrame) === null || _this_currentIFrame === void 0 ? void 0 : _this_currentIFrame.contentWindow) {
            this.currentIFrame.contentWindow.removeEventListener("keydown", this.proxyEvents);
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this_props = this.props, storyMode = _this_props.storyMode, content = _this_props.content, cBookLang = _this_props.cBookLang;
        if (prevProps.storyMode !== storyMode || !isEqual(prevProps.content, content)) {
            this.setIFrameLang(cBookLang);
            applyColorMode();
            if (!storyMode && content && content.book_mode && content.book_mode.enabled) {
                var _this_bookModeRef, _this_storyModeRef;
                ((_this_bookModeRef = this.bookModeRef) === null || _this_bookModeRef === void 0 ? void 0 : _this_bookModeRef.current) && this.bookModeRef.current.setAttribute("style", "opacity: 1; display: block;");
                ((_this_storyModeRef = this.storyModeRef) === null || _this_storyModeRef === void 0 ? void 0 : _this_storyModeRef.current) && this.storyModeRef.current.setAttribute("style", "opacity: 0; display: none;");
            } else {
                var _this_bookModeRef1, _this_storyModeRef1;
                ((_this_bookModeRef1 = this.bookModeRef) === null || _this_bookModeRef1 === void 0 ? void 0 : _this_bookModeRef1.current) && this.bookModeRef.current.setAttribute("style", "opacity: 0; display: none;");
                ((_this_storyModeRef1 = this.storyModeRef) === null || _this_storyModeRef1 === void 0 ? void 0 : _this_storyModeRef1.current) && this.storyModeRef.current.setAttribute("style", "opacity: 1; display: block;");
            }
        }
    };
    _proto.render = function render() {
        var _this_props = this.props, content = _this_props.content, chart = _this_props.chart, customClass = _this_props.customClass;
        return /*#__PURE__*/ React.createElement("div", {
            className: "chart chart--extension ".concat(customClass || ""),
            id: "main chart-".concat(content && content.id)
        }, content && chart ? this.renderExtension() : null, content && content.book_mode && content.book_mode.enabled ? this.renderBookMode() : null);
    };
    _proto.renderExtension = function renderExtension() {
        var _this = this;
        var _this_props = this.props, chart = _this_props.chart, content = _this_props.content, complete = _this_props.complete, pushError = _this_props.pushError, cBookLang = _this_props.cBookLang, APISession = _this_props.APISession;
        return /*#__PURE__*/ React.createElement("div", {
            className: "storymode extension-container",
            ref: this.storyModeRef
        }, /*#__PURE__*/ React.createElement("iframe", {
            allowFullScreen: true,
            className: "chart__iframe",
            id: "ext-iframe",
            title: "".concat((chart === null || chart === void 0 ? void 0 : chart.name) ? chart.name.replace(/ /g, "") : "extension"),
            ref: function(iframe) {
                _this.currentIFrame = iframe;
                if (iframe) {
                    ExtensionAPI.removeSessionsByFrame(iframe);
                    var session = APISession || ExtensionAPI.createSession({
                        scope: {
                            chartId: chart === null || chart === void 0 ? void 0 : chart.id,
                            frame: iframe
                        },
                        type: "frontend"
                    });
                    if (!session._isAlreadyBound("error", pushError)) {
                        session.on("error", pushError);
                    }
                    var cl = function(_frame) {
                        return checkLoaded(_frame, function(frame) {
                            if (!frame || !frame.contentWindow) {
                                return;
                            }
                            // This is necessary because if a user reloads the iframe by his own, we have to guarantee that the API can be found
                            if (!frame.contentWindow.ExtensionAPI) {
                                frame.contentWindow.ExtensionAPI = session;
                                frame.contentWindow.onerror = function(message, source, lineno, colno, error) {
                                    if (error) {
                                        pushError(error);
                                    }
                                    return true;
                                };
                                frame.contentWindow.onunload = function() {
                                    return setTimeout(function() {
                                        return cl(frame);
                                    }, 50);
                                };
                            }
                            var _sessions = window.ExtensionAPI2 && window.ExtensionAPI2._sessions;
                            if (_sessions && _sessions.length && _this.v2sid !== _sessions[_sessions.length - 1]._sessionId) {
                                _this.v2sid = _sessions[_sessions.length - 1]._sessionId;
                                _sessions[_sessions.length - 1].subscribe().then(function(param) {
                                    var type = param.type, payload = param.payload;
                                    var _type_split = _slicedToArray(type.split(":"), 2), methode = _type_split[1];
                                    if (methode === "error") {
                                        pushError(payload);
                                    }
                                }).catch(pushError);
                            }
                        });
                    };
                    if (iframe && iframe.contentWindow) {
                        iframe.contentWindow.ExtensionAPI = session;
                        iframe.contentWindow.onerror = function(message, source, lineno, colno, error) {
                            if (error) {
                                pushError(error);
                            }
                            return true;
                        };
                        iframe.contentWindow.onunload = function() {
                            return setTimeout(function() {
                                return cl(iframe);
                            }, 50);
                        };
                        iframe.contentWindow.onload = function() {
                            applyColorMode();
                            _this.setIFrameLang(cBookLang);
                            _this.applyClassesToIframe();
                            if (!!chart && (!chart.capabilities || chart.capabilities.indexOf("completes_slide") === -1) && complete) {
                                complete(chart.id);
                            }
                        };
                    }
                    cl(iframe);
                }
            },
            src: (content === null || content === void 0 ? void 0 : content.urls) && content.urls.show ? content.urls.show + "?cid=" + String(content.id) : "",
            key: "cframe-" + String(content === null || content === void 0 ? void 0 : content.id)
        }));
    };
    _proto.renderBookMode = function renderBookMode() {
        var _this_props_content;
        var bookMode = ((_this_props_content = this.props.content) === null || _this_props_content === void 0 ? void 0 : _this_props_content.book_mode) || null;
        var style = {};
        var BMStyle = {
            opacity: 0,
            display: "none"
        };
        if (bookMode === null || bookMode === void 0 ? void 0 : bookMode.background_image) {
            style.backgroundImage = "url('".concat(encodeURI(bookMode.background_image.file.url), "')");
        }
        if (!this.props.storyMode) {
            BMStyle.display = "block";
            BMStyle.opacity = 1;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: "bookmode mediapage-bookmode clientcss",
            style: BMStyle,
            "aria-hidden": this.props.storyMode,
            ref: this.bookModeRef
        }, /*#__PURE__*/ React.createElement("div", {
            className: "mce-content-body clientcss__body",
            style: style,
            dangerouslySetInnerHTML: {
                __html: (bookMode === null || bookMode === void 0 ? void 0 : bookMode.content) || ""
            }
        }));
    };
    _proto.applyClassesToIframe = function applyClassesToIframe() {
        var _this_props = this.props, cbook = _this_props.cbook, chart = _this_props.chart;
        updateFontSize(getFontSize());
        updateContrast(getContrast());
        updateBackgroundOption(getBackgroundOption());
        updateBodyClass(null, "custom-root-".concat(cbook === null || cbook === void 0 ? void 0 : cbook.slug));
        updateBodyClass(null, "slide-id-".concat(chart === null || chart === void 0 ? void 0 : chart.target_id));
        updateBodyClass(null, "slide-type-extension");
    };
    _proto.setIFrameLang = function setIFrameLang(lang) {
        var _document_getElementsByClassName_;
        var node = (_document_getElementsByClassName_ = document === null || document === void 0 ? void 0 : document.getElementsByClassName("chart__iframe")[0]) === null || _document_getElementsByClassName_ === void 0 ? void 0 : _document_getElementsByClassName_.contentWindow.document.getElementsByTagName("html")[0];
        var a = document.createAttribute("lang");
        a.value = lang;
        if (node) {
            node.setAttributeNode(a);
        } else {
            console.warn("The extension iframe's html node could not be found. Lang attribute could not be set.");
        }
    };
    return ExtensionTemplate;
}(React.Component);
export var Component = ExtensionTemplate;
export default ExtensionTemplate;
